import { render, staticRenderFns } from "./site-type.vue?vue&type=template&id=c2ac83d8&scoped=true&"
import script from "./site-type.vue?vue&type=script&lang=js&"
export * from "./site-type.vue?vue&type=script&lang=js&"
import style0 from "./site-type.vue?vue&type=style&index=0&id=c2ac83d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ac83d8",
  null
  
)

export default component.exports